import { IProjectJson } from '@scale/shared/types/project';
import { useQuery } from 'react-query';
import {
  setProjectSelector,
  useStatContextStore,
} from 'react-scale/components/ExpertManagement/stores/statContext.store';
import apiFetch, { defaultApiFetchErrorHandler } from 'react-scale/lib/api-fetch';
import { shallow } from 'zustand/shallow';

export const useFetchProject = (projectId: string) => {
  const setProject = useStatContextStore(setProjectSelector, shallow);
  return useQuery(
    [`fetchProject`, projectId],
    () =>
      apiFetch<IProjectJson>(null, `internal/remo-admin/projects/${projectId}`, {
        method: 'GET',
      }),
    {
      onSuccess: data => {
        if (data?._id === projectId && data?.name) {
          setProject({ label: `${data.name} (${data._id})`, value: data._id });
        }
      },
      enabled: false,
      retry: false,
      onError: (e: any) => defaultApiFetchErrorHandler(e, { handleHttp: true }),
    },
  );
};
